import { faRotate } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const getNestedValue = (obj, path) => {
  return path.split(".").reduce((acc, part) => acc && acc[part], obj);
};

export const renderDataCellLotsAdm = (item, col, context, idx) => {
  const value = getNestedValue(item, col.key);

  switch (col.admData) {
    case "Admin actions":
      return (
        <td key={`actions-${idx}`}>
          <button
            className="btn ActionsButton"
            title={context.t("Relaunch docs instance status")}
            onClick={() => context.handleRelaunchClick(item)}
          >
            <FontAwesomeIcon
              icon={faRotate}
              style={{ marginRight: "5px" }}
              className="fa-copy"
            />
          </button>
        </td>
      );
    default:
      return (
        <td
          key={`default-${idx}`}
          style={{
            fontWeight: col.bold ? "bold" : "normal",
            width: "100px",
            fontSize: "14px",
          }}
        >
          {value}
        </td>
      );
  }
};
